﻿import { AccountRow } from "@/ServerTypes/Data/AccountRow";
import { Decorators } from "@serenity-is/corelib";
import { FormatServiceLookupPickerBase, FormatServiceLookupEditorOptions } from "@/Data/List/FormatServiceLookupEditor";
import { AccountPickerDialog } from "./AccountPickerDialog";
import { AccountService } from "@/ServerTypes/Data/AccountService";

export interface AccountPickerOptions extends FormatServiceLookupEditorOptions {
    filterField?: string;
    filterValue?: string;
    multiple?: boolean;
}

@Decorators.registerEditor("Matrix.Data.AccountPicker")
export class AccountPicker extends FormatServiceLookupPickerBase<AccountPickerOptions, AccountRow>  {

    constructor(hidden: JQuery, options: AccountPickerOptions) {
        if (!options.idField?.length)
            options.idField = AccountRow.idProperty;
        if (!options.textField?.length)
            options.textField = AccountRow.nameProperty;
        if (!options.resultFormat?.length)
            options.service = AccountService.baseUrl + "/List";

        super(hidden, options);
    }
    handleEditClick() {
        var dlg = new AccountPickerDialog();
        dlg.criteria = this.getFilterCriteria();
        dlg.value = this.values;
        dlg.dialogOpen();
        dlg.onSuccess = sel => {
            this.values = dlg.value;
            return true;
        }
    }

    protected getLookupKey() {
        return AccountRow.lookupKey;
    }

    protected displayName() {
        return "accounts";
    }
}
